import React, { useState } from "react";
import {
  Link,
  useLocation,
  Outlet,
  useNavigate,
} from "react-router-dom";



const MenuIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-6 h-6"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  </svg>
);

const ChiefComplaintsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
  </svg>
);

const QAIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 1 1 5.82 1c0 1.5-1.5 2-2 2" />
    <line x1="12" y1="17" x2="12" y2="17" />
  </svg>
);

const PregnancyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="8" r="4" />
    <path d="M5.5 20a8.38 8.38 0 0 1 13 0" />
    <path d="M12 12v4" />
  </svg>
);

const PrescriptionIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16l4-4h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" />
    <line x1="8" y1="11" x2="12" y2="11" />
    <line x1="8" y1="15" x2="12" y2="15" />
  </svg>
);

const ReportIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <line x1="8" y1="9" x2="16" y2="9" />
    <line x1="8" y1="13" x2="16" y2="13" />
    <line x1="8" y1="17" x2="16" y2="17" />
  </svg>
);

const HealthStatsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l9 9 9-9a5.5 5.5 0 0 0 0-7.8z" />
    <polyline points="9 11 11 13 15 9" />
  </svg>
);

const ChatIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
  </svg>
);

const LogoutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-6 h-6"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const PaymentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="5" width="20" height="14" rx="2" ry="2"></rect>
    <line x1="2" y1="10" x2="22" y2="10"></line>
  </svg>
);

const DoctorIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
    <path d="M9 14h6" />
    <path d="M9 18h6" />
    <path d="M12 14v4" />
  </svg>
);

const BraceletIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    <path d="M12 6v12M8 12h8" />
    <circle cx="12" cy="12" r="3" />
    <path d="M6 12h2M16 12h2" />
  </svg>
);

const UserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const ShoppingCartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="9" cy="21" r="1" />
    <circle cx="20" cy="21" r="1" />
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
  </svg>
);

const SkinIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <circle cx="8" cy="8" r="1.5" />
    <circle cx="16" cy="8" r="1.5" />
    <path d="M8 14c0 2 2 4 4 4s4-2 4-4" />
  </svg>
);


const MobileNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);



  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("user_info");
    navigate("/");
  };

  const navItems = [
    {
      path: "/health-summary",
      icon: <HealthStatsIcon />,
      label: "স্বাস্থ্য সংক্ষেপ",
      abbr: "Health Summary",
    },
    {
      path: "/browse-health-categories",
      icon: <HealthStatsIcon />,
      label: "স্বাস্থ্য বিভাগ",
      abbr: "Health Categories",
    },
    {
      path: "/landing/tab1",
      icon: <ChiefComplaintsIcon />,
      label: "সমস্যা বলুন",
      abbr: "CC",
    },
    {
      path: "/consult-doctor",
      icon: <DoctorIcon />,
      label: "ডাক্তার দেখান",
      abbr: "Consult Doctor",
    },
    {
      path: "/landing/questionanswer",
      icon: <QAIcon />,
      label: "প্রশ্নোত্তর",
      abbr: "Q&A",
    },
    {
      path: "/skin-disease",
      icon: <SkinIcon />,
      label: "চর্মরোগ",
      abbr: "Dermatology",
    },
    {
      path: "/landing/pregnancyriskeval",
      icon: <PregnancyIcon />,
      label: "গর্ভকালীন সমস্যা",
      abbr: "Pregnancy",
    },
    {
      path: "/tab2/Prescription",
      icon: <PrescriptionIcon />,
      label: "প্রেসক্রিপশন",
      abbr: "Prescription",
    },
    {
      path: "/tab2/Reports",
      icon: <ReportIcon />,
      label: "রিপোর্ট",
      abbr: "Report",
    },
    {
      path: "/chat",
      icon: <ChatIcon />,
      label: "চ্যাট",
      abbr: "Chat",
    },
    {
      path: "/landing/tab3",
      icon: <BraceletIcon />,
      label: "শক্তি ব্যান্ড",
      abbr: "Wellness",
    },
    {
      path: "/on-exam",
      icon: <DoctorIcon />,
      label: "On Exam",
      abbr: "On Exam",
    },
    {
      path: "/profile",
      icon: <UserIcon />,
      label: "ব্যাবহারকারী",
      abbr: "Profile",
    },
    {
      path: "/products",
      icon: <ShoppingCartIcon />,
      label: "পণ্য কিনুন",
      abbr: "Buy Products",
    },
    // {
    //   path: "/payment",
    //   icon: <PaymentIcon />,
    //   label: "পেমেন্ট",
    //   abbr: "Payment",
    // },
    {
      path: "/logout",
      icon: <LogoutIcon />,
      label: "লগআউট",
      abbr: "Logout",
      onClick: handleLogout,
    },
  ];

  return (
    <>
      {/* Fixed header with hamburger menu */}
      <header className="fixed top-0 left-0 right-0 bg-white h-14 shadow-md z-10 flex items-center justify-between px-4">
        <div className="text-lg font-semibold text-blue-600">সেমিয়ন হেলথ</div>
        <button
          onClick={toggleMenu}
          className="p-2 text-gray-600 hover:text-blue-600 focus:outline-none"
        >
          <MenuIcon />
        </button>
      </header>

      {/* Full screen sidebar */}
      <div
        className={`fixed inset-0 bg-white z-50 transform transition-transform duration-300 ease-in-out ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full">
          {/* Sidebar Header with close button */}
          <div className="px-4 py-4 border-b border-gray-100 flex justify-between items-center">
            <div className="text-lg font-semibold text-blue-600">সেমিয়ন হেলথ</div>
            <button
              onClick={closeMenu}
              className="p-2 text-gray-600 hover:text-blue-600 focus:outline-none"
            >
              <CloseIcon />
            </button>
          </div>

          {/* Navigation Items */}
          <nav className="flex-1 py-2">
            <ul className="space-y-1">
              {navItems.map((item, index) => {
                const isActive = location.pathname === item.path || 
                  (item.path === "/products" && location.pathname.startsWith("/products")) ||
                  (item.path === "/on-exam" && location.pathname.startsWith("/on-exam"));
                return (
                  <li key={index}>
                    {item.onClick ? (
                      <button
                        onClick={() => {
                          closeMenu();
                          item.onClick();
                        }}
                        className="flex items-center w-full px-4 py-2 text-red-600 hover:bg-red-50 transition-colors duration-200"
                      >
                        <span className="text-red-600">{item.icon}</span>
                        <span className="ml-3 font-medium">{item.label}</span>
                      </button>
                    ) : (
                      <Link
                        to={item.path}
                        onClick={closeMenu}
                        className={`flex items-center px-4 py-2 ${
                          isActive
                            ? "bg-blue-50 text-blue-600 border-l-4 border-blue-600"
                            : "text-gray-700 hover:bg-gray-100"
                        }`}
                      >
                        <span
                          className={`${
                            isActive ? "text-blue-600" : "text-gray-500"
                          }`}
                        >
                          {item.icon}
                        </span>
                        <span className="ml-3 font-medium">{item.label}</span>
                      </Link>
                    )}
                  </li>
                );
              })}
            </ul>
          </nav>


        </div>
      </div>

      {/* Main content area with padding for fixed header */}
      <main className="pt-14 pb-1 px-1 bg-gray-50" style={{ 
        height: 'calc(100vh - 56px)', 
        overflow: 'hidden',
        position: 'relative'
      }}>
        <div className="absolute inset-0 pt-0 pb-1 px-1 overflow-y-auto" style={{
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch'
        }}>
          <Outlet />
        </div>
      </main>
    </>
  );
};
export default MobileNav;
